module.exports = __webpack_public_path__ + "img/full-screen.921304d1.svg";